<right-menu-container [title]="'Released Tasks'" [showBackArrow]="false" *ngIf="board.sprintReleased">
  <released-tasks-list [boardId]="board.id"></released-tasks-list>
</right-menu-container>
